<template>
    <div>
        <station-group-information />
        <station-view-information />
        <station-location-card />
        <station-sensors-card />
        <station-region-modal v-if="regionModal && (user.role === 'super_admin' || user.role === 'admin')" />
        <station-fetch-perco-data-modal v-if="percoModal" />
        <station-merge-station-modal v-if="mergeStationModal && user.role === 'super_admin'" />
        <station-states-card />
    </div>
</template>

<script>
import StationViewInformation from '../../components/station/StationViewInformation'
import { mapActions, mapState } from 'vuex'
import StationLocationCard from '../../components/station/StationLocationCard'
import StationSensorsCard from '../../components/station/StationSensorsCard'
import StationFetchPercoDataModal from '../../components/station/StationFetchPercoDataModal'
import StationStatesCard from '../../components/station/StationStatesCard'
import StationRegionModal from '../../components/station/StationRegionModal.vue'
import StationGroupInformation from '../../components/station/StationGroupInformation.vue';
import StationMergeStationModal from '../../components/station/StationMergeStationModal.vue';

export default {
    name: 'StationView',
    components: {
        'station-group-information': StationGroupInformation,
        'station-view-information': StationViewInformation,
        'station-location-card': StationLocationCard,
        'station-sensors-card': StationSensorsCard,
        'station-fetch-perco-data-modal': StationFetchPercoDataModal,
        'station-states-card': StationStatesCard,
        'station-region-modal': StationRegionModal,
        'station-merge-station-modal': StationMergeStationModal,
    },
    mounted() {
        this.fetchProbe(this.$route.params.id)
        this.fetchCulture()
    },
    methods: {
        ...mapActions('probe', ['fetchProbe']),
        ...mapActions('culture', ['fetchCulture']),
    },
    computed: {
        ...mapState('probe', ['percoModal', 'regionModal', 'mergeStationModal']),
        ...mapState('auth', ['user']),
    },
}
</script>

<style scoped></style>
